import axios from '../axios';
import { getLiveStreamApiURL, getLiveZoneCameras, getLiveZones } from './liveZones';

export const getLiveReportCameras = getLiveZoneCameras;

export const getLiveReportZones = async ({ clientId, cameraId, viewId }) => {
  if (!clientId || !cameraId) return [];
  const zones = await getLiveZones({ cameraId, viewId });
  return zones.map((zone) => ({ ...zone, id: String(zone.id) }));
};

export const getLiveZoneReport = async (filters) => {
  const response = await axios.post(getLiveStreamApiURL('analytics'), {
    camera_id: Number(filters.cameraId),
    view_id: Number(filters.viewId),
    start: new Date(filters.startDateTime).toISOString(),
    end: new Date(filters.endDateTime).toISOString(),
    zone_ids: filters.zoneIds.map(Number),
    metric: 'presence',
    timezone: filters.timezone,
  }, { headers: { 'Content-Type': 'application/json' }, timeout: 60000 });
  if (!response.data || !Array.isArray(response.data.zones)) throw new Error('Invalid analytics response');
  return response.data;
};

export const renderLiveReportHeatmap = async (report, { signal } = {}) => {
  const response = await axios.post(getLiveStreamApiURL('heatmap/render'), {
    camera_id: Number(report.camera.deviceid),
    view_id: Number(report.view_id),
    heatmap: report.heatmap,
    covered_seconds: report.summary?.covered_seconds ?? 0,
    display: {
      opacity: 0.82,
      smoothing: 2.2,
      background: 'blue',
      brightness: 1,
      scale_mode: 'fixed',
      maximum: 30,
    },
  }, {
    headers: { 'Content-Type': 'application/json' }, timeout: 60000,
    ...(signal ? { signal } : {}),
  });
  const rendering = response.data?.rendering;
  if (!rendering || (rendering.available && !rendering.overlay_png?.startsWith('data:image/png;base64,'))) {
    throw new Error('Invalid heatmap render response');
  }
  return rendering;
};
